/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesGamesChooseGameTurnstileOptions
 */
export interface FxIdWebFeaturesGamesChooseGameTurnstileOptions {
    /**
     * Публичный ключ для Cloudflare Turnstile
     * @type {string}
     * @memberof FxIdWebFeaturesGamesChooseGameTurnstileOptions
     */
    SiteKey: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesGamesChooseGameTurnstileOptions interface.
 */
export function instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions(value: object): value is FxIdWebFeaturesGamesChooseGameTurnstileOptions {
    if (!('SiteKey' in value) || value['SiteKey'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSON(json: any): FxIdWebFeaturesGamesChooseGameTurnstileOptions {
    return FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesGamesChooseGameTurnstileOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'SiteKey': json['SiteKey'],
    };
}

export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSON(json: any): FxIdWebFeaturesGamesChooseGameTurnstileOptions {
    return FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSONTyped(value?: FxIdWebFeaturesGamesChooseGameTurnstileOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SiteKey': value['SiteKey'],
    };
}

